import React, { useContext, useEffect, useRef, useState } from 'react';
import { getImageFromS3 } from '../imageService';
import styles from '../components/sms-prl-reg/index.module.scss';
import { DataLayerEventContext } from '../contexts/dataLayerEventContext';

const shopLink = {
  cigPoshta:
    'https://cig-poshta.in.ua/shop/parliament/?utm_source=CDAsmsPRLM_Nov',
  rozetka:
    'https://rozetka.com.ua/ua/sigareti/c4638591/producer=parliament/?utm_source=PMUsmsPRLM_Nov'
};

const extendedTextElements = [
  {
    id: 1,
    html: `<div
        style="
          font-size: 22px;
          font-style: normal;
          font-weight: 700;
          line-height: 120%;
          letter-spacing: 1.54px;
          text-align: center;
          padding-right: 20vw;
          text-transform: uppercase;
        "
      >
        ЛІНІЙКА <br/>
        У СТАНДАРТНОМУ <br/>
        ФОРМАТІ KING SIZE
      </div>`,
    showAt: 0,
    hideAt: 550
  },
  {
    id: 'empty-1',
    html: '',
    showAt: 551,
    hideAt: 2299,
    isEmpty: true
  },
  {
    id: 2,
    html: `<div style="color: #FFF; font-style: normal; text-transform: uppercase; font-weight: 700;">
      <p
        style="
          font-size: 30px;
          letter-spacing: 2.1px;
          line-height: 120%;
        "
      >
        МЕТАЛІЗОВАНА
      </p>
      <p
        style="
          font-size: 22px;
          letter-spacing: 1.54px;
          line-height: 120%;
        "
      >
      ЗОНА ЛОГОТИПУ
      </p>
    </div>`,
    showAt: 2300,
    hideAt: 3400
  },
  {
    id: 'empty-2',
    html: '',
    showAt: 3401,
    hideAt: 3999,
    isEmpty: true
  },
  {
    id: 3,
    html: `<div style="color: #FFF; font-style: normal; text-transform: uppercase; font-weight: 700;">
      <p
        style="
          font-size: 30px;
          letter-spacing: 2.1px;
          line-height: 120%;
        "
      >
        ВИРОБЛЕНО
      </p>
      <p
        style="
          font-size: 22px;
          letter-spacing: 1.54px;
          line-height: 120%;
        "
      >
        НА ВЛАСНІЙ </br> ФАБРИЦІ В УКРАЇНІ
      </p>
    </div>`,
    showAt: 4000,
    hideAt: 4400
  },
  {
    id: 'empty-3',
    html: '',
    showAt: 4401,
    hideAt: 6499,
    isEmpty: true
  },
  {
    id: 4,
    html: `<div style="color: #FFF; font-style: normal; text-transform: uppercase; font-weight: 700;">
      <p
        style="
          font-size: 22px;
          letter-spacing: 1.54px;
          line-height: 120%;
        "
      >
        НАПИС <span style="font-size: 30px; letter-spacing: 2.1px;">PARLIAMENT</span>
      </p>
      <p
        style="
          font-size: 22px;
          letter-spacing: 1.54px;
          line-height: 120%;
        "
      >
        НА СИГАРЕТІ ТА <br /> ЗАХИСНОМУ ПАПЕРІ
      </p>
    </div>`,
    showAt: 6500,
    hideAt: 7700
  },
  {
    id: 'empty-4',
    html: '',
    showAt: 7701,
    hideAt: 8199,
    isEmpty: true
  },
  {
    id: 5,
    html: `<div style="color: #FFF; font-style: normal; text-transform: uppercase; font-weight: 700;">
      <p
        style="
          font-size: 30px;
          letter-spacing: 2.1px;
          line-height: 120%;
        "
      >
        КОЛЬОРОВА </br>ВНУТРІШНЯ
      </p>
      <p
        style="
          font-size: 22px;
          letter-spacing: 1.54px;
          line-height: 120%;
        "
      >
        РАМКА З ХАРАКТЕРНИМ </br> ДИЗАЙНОМ ТА QR-КОДОМ
      </p>
    </div>`,
    showAt: 8200,
    hideAt: 8800
  },
  {
    id: 'empty-5',
    html: '',
    showAt: 8801,
    hideAt: 10699,
    isEmpty: true
  },
  {
    id: 6,
    html: `
      <div
        style="
          font-size: 30px;
          font-style: normal;
          font-weight: 700;
          line-height: 120%;
          letter-spacing: 2.1px;
          text-align: center;
          padding-right: 20vw;
          text-transform: uppercase;
        "
      >
        RECESSED <br />2.0 Filter
      </div>`,
    showAt: 10700,
    hideAt: 10900
  },
  {
    id: 'empty-6',
    html: '',
    showAt: 10901,
    hideAt: 11099,
    isEmpty: true
  }
];

const LoadingSpinner = ({ progress }) => {
  const [activePosition, setActivePosition] = useState(0);
  const dotsCount = 8; // Кількість точок у колі

  // Ефект для анімації
  useEffect(() => {
    const interval = setInterval(() => {
      setActivePosition((prev) => (prev + 1) % dotsCount);
    }, 500); // Інтервал в пів секунди

    return () => clearInterval(interval);
  }, []);

  // Створюємо точки для ідеального кола
  const renderDots = () => {
    const dots = [];
    const radius = 30; // Радіус кола

    for (let i = 0; i < dotsCount; i++) {
      // Розрахунок позиції для кожної точки на колі (за годинниковою стрілкою)
      const angle = (i * 2 * Math.PI) / dotsCount - Math.PI / 2; // Починаємо з верхньої точки
      const x = Math.cos(angle) * radius;
      const y = Math.sin(angle) * radius;

      dots.push(
        <div
          key={i}
          style={{
            position: 'absolute',
            width: '8px',
            height: '8px',
            borderRadius: '50%',
            backgroundColor:
              activePosition === i ? '#fff' : 'rgba(255, 255, 255, 0.2)',
            transform: `translate(${x}px, ${y}px)`,
            transition: 'background-color 0.2s ease',
            left: '50%',
            top: '50%',
            marginLeft: '-4px', // Половина ширини точки
            marginTop: '-4px' // Половина висоти точки
          }}
        />
      );
    }

    return dots;
  };

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999
      }}
    >
      <img
        src={getImageFromS3('images/sms-prl-reg/preload-bg.png')}
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          zIndex: 1
        }}
        alt="preload-background-gradient"
      />
      <div
        style={{
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '30px',
          zIndex: 2
        }}
      >
        <div
          style={{
            position: 'relative',
            width: '66px',
            height: '66px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          {renderDots()}
        </div>
      </div>
    </div>
  );
};

const FINAL_BLOCK_POSITION = 11100;

const NEW_CONTENT_POSITION = 12000;

const tobaccoCircleLink = getImageFromS3(
  'images/sms-prl-reg/tobacco-circle.png'
);

const ScrollIcon = () => {
  return (
    <div className={styles.scrollIcon}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="80"
        height="100"
        viewBox="0 0 80 100"
        fill="none"
      >
        {/* Частина пальця (завжди показана) */}
        <path
          className={styles.fingerPart}
          d="M29.9739 66.1508L34.1488 71.7052C34.6911 72.4267 34.962 73.3165 34.9143 74.2199C34.8016 76.3524 32.9794 77.9987 30.8442 77.897L27.5575 77.7405C26.5528 77.6926 25.5612 77.9981 24.7553 78.6039C24.1715 79.0427 23.8894 79.7755 24.0296 80.4891L24.0729 80.7097C24.2369 81.5447 24.8737 82.2051 25.703 82.4003L44.0961 86.7289C47.0713 87.4291 50.211 86.7683 52.6619 84.9261C58.1095 80.8315 59.2237 73.1192 55.1507 67.7003L48.5952 58.9787C48.1426 58.3766 47.2851 58.2574 46.6798 58.7123C46.0745 59.1673 45.9507 60.0242 46.4032 60.6263L48.0421 62.8067C48.4947 63.4088 48.3709 64.2657 47.7656 64.7207C47.1603 65.1756 46.3027 65.0563 45.8502 64.4542L42.5724 60.0934C42.1199 59.4913 41.2623 59.3721 40.657 59.827C40.0517 60.282 39.9279 61.1389 40.3805 61.741L43.6582 66.1018C44.1108 66.7039 43.987 67.5608 43.3817 68.0158C42.7764 68.4707 41.9189 68.3514 41.4663 67.7493L36.5497 61.2081C36.0971 60.606 35.2396 60.4867 34.6343 60.9417C34.029 61.3967 33.9052 62.2536 34.3577 62.8557L39.2744 69.3969C39.7269 69.999 39.6031 70.8559 38.9978 71.3109C38.3926 71.7658 37.535 71.6465 37.0824 71.0444L25.6103 55.7816C25.1577 55.1795 24.3002 55.0602 23.6949 55.5152C23.0896 55.9702 22.9658 56.8271 23.4184 57.4292L29.9739 66.1508ZM27.7819 67.7983L21.2264 59.0767C19.8687 57.2704 20.2402 54.6997 22.056 53.3348C23.8719 51.9699 26.4445 52.3278 27.8022 54.1341L32.0393 59.7712C32.2915 59.393 32.6111 59.0502 32.9954 58.7613C34.5116 57.6216 36.5555 57.6831 37.9792 58.786C38.2429 58.3565 38.5904 57.9681 39.0181 57.6466C40.5344 56.5069 42.5783 56.5684 44.0019 57.6713C44.2656 57.2418 44.6132 56.8534 45.0409 56.5319C46.8568 55.167 49.4294 55.5249 50.7871 57.3312L57.3426 66.0528C62.3208 72.6759 60.9589 82.102 54.3008 87.1065C51.1976 89.4389 47.2225 90.2756 43.4555 89.3891L25.0624 85.0605C23.1927 84.6205 21.7569 83.1314 21.3871 81.2488L21.3438 81.0282C21.0014 79.2852 21.6904 77.4953 23.1165 76.4235C24.4351 75.4323 26.0576 74.9324 27.7018 75.0107L30.9885 75.1673C31.6142 75.1971 32.1482 74.7146 32.1812 74.0897C32.1952 73.825 32.1158 73.5642 31.9569 73.3528L27.7819 67.7983Z"
        />

        {/* Частина стрілки (анімована) - зсуваємо ще нижче, на відстань ~5px від пальця */}
        <path
          className={styles.arrowPart}
          d="M10 69.1817L13.8215 65.3803C14.4724 64.7329 15.5276 64.7329 16.1785 65.3803C16.8294 66.0278 16.8294 67.0775 16.1785 67.7249L9.51184 74.3565C8.86097 75.004 7.8057 75.004 7.15482 74.3565L0.488155 67.7249C-0.162718 67.0775 -0.162718 66.0278 0.488155 65.3803C1.13903 64.7329 2.1943 64.7329 2.84518 65.3803L6.66667 69.1817V46.6579C6.66667 45.7423 7.41286 45 8.33333 45C9.25381 45 10 45.7423 10 46.6579V69.1817Z"
        />
      </svg>
    </div>
  );
};

const SmsPrlReg = () => {
  const canvasRef = useRef(null);
  const containerRef = useRef(null);
  const frameCount = 650; // Повертаємо повну кількість кадрів
  const imagesRef = useRef(new Array(frameCount).fill(null));
  const loadedFrames = useRef(new Set());
  const [isPreloaded, setIsPreloaded] = useState(false);
  const [loadingProgress, setLoadingProgress] = useState(0);
  const scrollPosition = useRef(0);
  const lastTouchY = useRef(0);
  const [canvasSize, setCanvasSize] = useState({
    width: 0,
    height: 0,
    cssWidth: 0,
    cssHeight: 0
  });
  const { init, sendEvent } = useContext(DataLayerEventContext);

  useEffect(() => {
    init('sms-prl-reg');
    sendEvent('age_verification_without');
    sessionStorage.setItem('unsubscription_source', 'Parliament_Main_Line');
  }, [init]);

  const momentum = useRef(0);
  const isScrolling = useRef(false);
  const animationFrameId = useRef(null);
  const MIN_MOMENTUM = 0.1;

  const [visibleTexts, setVisibleTexts] = useState([]);

  const snapToTextTimeout = useRef(null);
  const isSnapping = useRef(false);
  const lastUserInteraction = useRef(Date.now());
  const [initialLoadComplete, setInitialLoadComplete] = useState(false);
  const [totalLoadingProgress, setTotalLoadingProgress] = useState(0);

  // Додаємо новий стан для відстеження загального прогресу
  const [totalProgress, setTotalProgress] = useState(0);

  // Додаємо новий стан для відображення фінального блоку
  const [showFinalBlock, setShowFinalBlock] = useState(false);

  // Додаємо стан для відстеження чи показувати новий блок контенту
  const [showNewContent, setShowNewContent] = useState(false);

  // Додаємо новий стан для відображення іконки скролу та змінюємо ref для відстеження, чи була вона прихована
  const [showScrollIcon, setShowScrollIcon] = useState(true);
  const wasScrollIconHidden = useRef(false); // Додаємо ref для відстеження, чи була іконка прихована

  // Додаємо ref для батьківського контейнера
  const parentContainerRef = useRef(null);

  useEffect(() => {
    const updateCanvasSize = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;
      const pixelRatio = window.devicePixelRatio || 1;

      const scale = 1.5;

      setCanvasSize({
        width: width * pixelRatio * scale,
        height: width * pixelRatio * scale,
        cssWidth: width * scale,
        cssHeight: width * scale
      });
    };

    updateCanvasSize();
    window.addEventListener('resize', updateCanvasSize);

    return () => window.removeEventListener('resize', updateCanvasSize);
  }, []);

  // Оновлюємо useEffect для завантаження зображень
  useEffect(() => {
    const loadImageBatch = async (start, end) => {
      for (let i = start; i < end && i < frameCount; i++) {
        if (loadedFrames.current.has(i)) continue;

        const frameNumber = String(i + 1).padStart(3, '0');
        const imgSrc = getImageFromS3(
          `images/sms-prl-reg/005_2_${frameNumber}_result.webp`
        );

        const img = new Image();
        img.src = imgSrc;

        img.onload = () => {
          imagesRef.current[i] = img;
          loadedFrames.current.add(i);

          // Оновлюємо загальний прогрес
          const progress = Math.floor(
            (loadedFrames.current.size / frameCount) * 100
          );
          setTotalProgress(progress);

          // Обчислюємо кількість завантажених кадрів з першої половини
          const halfFrames = Math.floor(frameCount / 2); // 325 кадрів
          const loadedFirstHalf = Array.from(loadedFrames.current).filter(
            (idx) => idx < halfFrames
          ).length;
          const firstHalfProgress = Math.floor(
            (loadedFirstHalf / halfFrames) * 100
          );

          // Показуємо сайт після завантаження всіх кадрів першої половини
          if (firstHalfProgress >= 100 && !initialLoadComplete) {
            console.log('Завантажено першу половину кадрів. Показуємо сайт.');
            setInitialLoadComplete(true);
            setIsPreloaded(true);
          }

          // Оновлюємо загальний прогрес завантаження
          setTotalLoadingProgress(progress);
        };

        img.onerror = () => {
          console.warn(`⚠️ Пропущено кадр: ${frameNumber}`);
          // Позначаємо як завантажений, щоб не застрягати на помилкових кадрах
          loadedFrames.current.add(i);

          // Перевіряємо прогрес навіть при помилці
          // Обчислюємо кількість завантажених кадрів з першої половини
          const halfFrames = Math.floor(frameCount / 2); // 325 кадрів
          const loadedFirstHalf = Array.from(loadedFrames.current).filter(
            (idx) => idx < halfFrames
          ).length;
          const firstHalfProgress = Math.floor(
            (loadedFirstHalf / halfFrames) * 100
          );

          // Показуємо сайт після завантаження всіх кадрів першої половини
          if (firstHalfProgress >= 100 && !initialLoadComplete) {
            console.log(
              'Завантажено першу половину кадрів (з помилками). Показуємо сайт.'
            );
            setInitialLoadComplete(true);
            setIsPreloaded(true);
          }
        };
      }
    };

    // Оптимізована стратегія завантаження - спочатку перша половина
    const loadImages = () => {
      console.log('Запускаємо оптимізоване завантаження зображень...');

      const halfFrames = Math.floor(frameCount / 2); // 325 кадрів

      // Спочатку завантажуємо перші 50% кадрів
      console.log(`Завантажуємо першу половину (${halfFrames} кадрів)...`);

      // Завантажуємо першу половину пакетами по 50 кадрів
      for (let i = 0; i < halfFrames; i += 50) {
        const batchEnd = Math.min(i + 50, halfFrames);
        setTimeout(() => {
          loadImageBatch(i, batchEnd);
        }, i * 10); // Невелика затримка між пакетами
      }

      // Перевіряємо чи завантажилась перша половина
      const checkFirstHalfLoaded = setInterval(() => {
        const loadedFirstHalf = Array.from(loadedFrames.current).filter(
          (idx) => idx < halfFrames
        ).length;
        const firstHalfProgress = Math.floor(
          (loadedFirstHalf / halfFrames) * 100
        );

        if (firstHalfProgress >= 95) {
          // Якщо завантажено 95% першої половини
          clearInterval(checkFirstHalfLoaded);

          // Запускаємо завантаження другої половини
          console.log(
            'Перша половина завантажена, починаємо завантаження другої половини...'
          );
          loadSecondHalf();
        }
      }, 1000);

      // Функція для завантаження другої половини
      const loadSecondHalf = () => {
        // Завантажуємо другу половину пакетами по 50 кадрів
        for (let i = halfFrames; i < frameCount; i += 50) {
          const batchEnd = Math.min(i + 50, frameCount);
          setTimeout(
            () => {
              loadImageBatch(i, batchEnd);
            },
            (i - halfFrames) * 10
          ); // Невелика затримка між пакетами
        }
      };

      // Аварійний таймаут - якщо щось пішло не так, показуємо сайт через 60 секунд
      const emergencyTimeout = setTimeout(() => {
        if (!initialLoadComplete) {
          console.log('Аварійний таймаут - показуємо сайт.');
          setInitialLoadComplete(true);
          setIsPreloaded(true);
        }
      }, 60000); // 60 секунд

      return () => {
        clearInterval(checkFirstHalfLoaded);
        clearTimeout(emergencyTimeout);
      };
    };

    // Запускаємо завантаження
    return loadImages();
  }, []);

  // Спрощена функція рендерингу кадру
  const renderFrame = (frameIndex) => {
    const canvas = canvasRef.current;
    const ctx = canvas?.getContext('2d');

    // Шукаємо найближчий доступний кадр
    let validFrame = frameIndex;
    while (!loadedFrames.current.has(validFrame) && validFrame > 0) {
      validFrame--;
    }

    if (canvas && ctx && imagesRef.current[validFrame]) {
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = 'high';

      requestAnimationFrame(() => {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(
          imagesRef.current[validFrame],
          0,
          0,
          canvas.width,
          canvas.height
        );
      });
    }
  };

  // Оновлюємо функцію updateVisibleTexts
  const updateVisibleTexts = (currentPosition) => {
    // Знаходимо поточний видимий текст
    const currentVisibleTexts = extendedTextElements
      .filter(
        (item) =>
          currentPosition >= item.showAt && currentPosition <= item.hideAt
      )
      .map((item) => item.id);

    // Перевіряємо, чи користувач проскролив далі за блок empty-1
    const empty1Block = extendedTextElements.find(
      (item) => item.id === 'empty-1'
    );
    if (
      empty1Block &&
      currentPosition > empty1Block.hideAt &&
      !wasScrollIconHidden.current
    ) {
      setShowScrollIcon(false);
      wasScrollIconHidden.current = true; // Позначаємо, що іконка була прихована
    }

    // Оновлюємо тільки якщо відбулися зміни
    if (JSON.stringify(currentVisibleTexts) !== JSON.stringify(visibleTexts)) {
      console.log(
        'Позиція:',
        currentPosition,
        'Видимі тексти:',
        currentVisibleTexts
      );
      setVisibleTexts(currentVisibleTexts);
    }
  };

  // Оновлюємо функцію findNearestTextPosition
  const findNearestTextPosition = () => {
    const currentPos = scrollPosition.current;

    // Перевіряємо, чи ми вже в діапазоні якогось тексту
    const currentText = extendedTextElements.find(
      (item) => currentPos >= item.showAt && currentPos <= item.hideAt
    );

    if (currentText) {
      // Якщо ми в непустому блоці, не притягуємо нікуди
      if (!currentText.isEmpty) {
        return null;
      }

      // Знаходимо всі непусті тексти
      const nonEmptyTexts = extendedTextElements.filter(
        (item) => !item.isEmpty
      );

      // Знаходимо останній непустий текст
      const lastNonEmptyText = nonEmptyTexts[nonEmptyTexts.length - 1];

      // Якщо ми за останнім текстом, не притягуємо назад
      if (currentPos > lastNonEmptyText.hideAt) {
        console.log('Ми вже пройшли останній блок, не притягуємо назад');
        return null;
      }

      // Сортуємо за відстанню від поточної позиції
      nonEmptyTexts.sort((a, b) => {
        return (
          Math.abs(a.showAt - currentPos) - Math.abs(b.showAt - currentPos)
        );
      });

      // Повертаємо позицію найближчого непустого тексту + 50px
      if (nonEmptyTexts.length > 0) {
        const targetPosition = nonEmptyTexts[0].showAt + 50;
        console.log('Дотягуємо з пустого блоку до:', targetPosition);
        return targetPosition;
      }
    }

    // Якщо ми не в межах тексту взагалі, проводимо аналогічну перевірку
    const nonEmptyTexts = extendedTextElements.filter((item) => !item.isEmpty);
    const lastNonEmptyText = nonEmptyTexts[nonEmptyTexts.length - 1];

    // Якщо ми за останнім текстом, не притягуємо назад
    if (currentPos > lastNonEmptyText.hideAt) {
      console.log('Ми вже пройшли останній блок, не притягуємо назад');
      return null;
    }

    // Якщо ми не пройшли останній текст, шукаємо найближчий
    const allPositions = nonEmptyTexts.map((item) => ({
      pos: item.showAt + 50, // Додаємо зсув 50px до позиції showAt
      distance: Math.abs(item.showAt - currentPos)
    }));

    allPositions.sort((a, b) => a.distance - b.distance);

    // Притягуємо тільки якщо відстань менше 300px
    if (allPositions.length > 0 && allPositions[0].distance < 300) {
      console.log('Дотягуємо до найближчого тексту:', allPositions[0].pos);
      return allPositions[0].pos;
    }

    return null;
  };

  // Оновлюємо обробник завершення скролу для перевірки пустих блоків
  const checkEmptyBlockSnap = () => {
    // Отримуємо поточний блок
    const currentText = extendedTextElements.find(
      (item) =>
        scrollPosition.current >= item.showAt &&
        scrollPosition.current <= item.hideAt
    );

    // Якщо ми на пустому блоці, запускаємо доскрол до найближчого непустого
    if (currentText && currentText.isEmpty) {
      console.log('Зупинка на пустому блоці, шукаємо куди доскролити');

      // Спеціальна логіка для empty-1: завжди доскролюємо до другого блоку
      if (currentText.id === 'empty-1') {
        // Знаходимо другий блок з текстом (з id: 2)
        const secondTextBlock = extendedTextElements.find(
          (item) => item.id === 2
        );

        if (secondTextBlock) {
          const targetPosition = secondTextBlock.showAt + 50;
          console.log('Доскролюємо до блоку 2, позиція:', targetPosition);
          snapToPosition(targetPosition);
          return;
        }
      }

      // Для всіх інших пустих блоків використовуємо стандартну логіку
      // Знаходимо всі непусті тексти
      const nonEmptyTexts = extendedTextElements.filter(
        (item) => !item.isEmpty
      );

      // Знаходимо останній непустий текст
      const lastNonEmptyText = nonEmptyTexts[nonEmptyTexts.length - 1];

      // Якщо ми за останнім текстом, не доскролюємо назад
      if (scrollPosition.current > lastNonEmptyText.hideAt) {
        console.log('Ми вже пройшли останній блок, не доскролюємо назад');
        return;
      }

      // Сортуємо за відстанню від поточної позиції
      nonEmptyTexts.sort((a, b) => {
        return (
          Math.abs(a.showAt - scrollPosition.current) -
          Math.abs(b.showAt - scrollPosition.current)
        );
      });

      // Якщо є непусті тексти, доскролюємо до найближчого showAt + 50px
      if (nonEmptyTexts.length > 0) {
        const targetPosition = nonEmptyTexts[0].showAt + 50;
        console.log(
          'Доскролюємо до:',
          nonEmptyTexts[0].id,
          'позиція:',
          targetPosition
        );
        snapToPosition(targetPosition);
      }
    }
  };

  // Функція для плавного переходу до вказаної позиції з постійною швидкістю
  const snapToPosition = (targetPosition) => {
    if (targetPosition === null) return;

    isSnapping.current = true;

    // Визначаємо напрямок і відстань для руху
    const distance = targetPosition - scrollPosition.current;
    const direction = Math.sign(distance);

    // Збільшуємо швидкість доскролу - змінюємо значення з 15 на 25
    const step = 25 * direction; // Фіксована швидкість доскролу, можна налаштувати за потреби

    // Якщо ми ще не досягли цільової позиції і не було нової взаємодії
    if (
      Math.abs(distance) > Math.abs(step) &&
      Date.now() - lastUserInteraction.current >= 300
    ) {
      handleScroll(step);
      requestAnimationFrame(() => snapToPosition(targetPosition));
    } else {
      // Якщо залишилась відстань менша за крок - одразу встановлюємо фінальну позицію
      if (Math.abs(distance) <= Math.abs(step)) {
        scrollPosition.current = targetPosition;
        // Оновлюємо кадр і тексти
        const frameIndex = Math.min(
          frameCount - 1,
          Math.floor(
            (scrollPosition.current / NEW_CONTENT_POSITION) * frameCount
          )
        );
        renderFrame(frameIndex);
        updateVisibleTexts(scrollPosition.current);
      }
      // Досягли цільової позиції або була нова взаємодія
      isSnapping.current = false;
    }
  };

  // Оновлюємо функцію анімації інерції для короткого імпульсу з різкою зупинкою
  const animateInertia = () => {
    // Якщо відбувається притягування, не застосовуємо інерцію
    if (isSnapping.current) {
      // Оновлюємо видимість тексту під час притягування
      updateVisibleTexts(scrollPosition.current);
      animationFrameId.current = requestAnimationFrame(animateInertia);
      return;
    }

    if (Math.abs(momentum.current) > MIN_MOMENTUM) {
      // Застосовуємо інерцію
      handleScroll(momentum.current);

      // Лічильник кадрів інерції - різка зупинка після 5-10 кадрів
      momentum.current *= 0.8; // Сильніше затухання для коротшого імпульсу

      // Якщо швидкість стала занадто малою, різко зупиняємо
      if (Math.abs(momentum.current) < 2) {
        momentum.current = 0;
        isScrolling.current = false;

        // Після зупинки перевіряємо чи треба доскролити до текстового блоку
        if (snapToTextTimeout.current) {
          clearTimeout(snapToTextTimeout.current);
        }

        snapToTextTimeout.current = setTimeout(() => {
          checkEmptyBlockSnap();
        }, 500);
      }

      // Оновлюємо видимість тексту під час руху
      updateVisibleTexts(scrollPosition.current);
    } else if (isScrolling.current) {
      // Різко зупиняємо інерцію
      momentum.current = 0;
      isScrolling.current = false;

      // Очищаємо існуючий таймаут і запускаємо перевірку доскролу
      if (snapToTextTimeout.current) {
        clearTimeout(snapToTextTimeout.current);
      }

      // Запускаємо таймаут для перевірки пустого блоку
      snapToTextTimeout.current = setTimeout(() => {
        checkEmptyBlockSnap();
      }, 500);
    }

    animationFrameId.current = requestAnimationFrame(animateInertia);
  };

  useEffect(() => {
    if (isPreloaded) {
      renderFrame(0);
    }

    // Запускаємо анімаційний цикл для інерції
    const animateInertia = () => {
      // Якщо відбувається притягування, не застосовуємо інерцію
      if (isSnapping.current) {
        animationFrameId.current = requestAnimationFrame(animateInertia);
        return;
      }

      if (Math.abs(momentum.current) > MIN_MOMENTUM) {
        // Застосовуємо інерцію
        handleScroll(momentum.current);

        // Лічильник кадрів інерції - різка зупинка після 5-10 кадрів
        momentum.current *= 0.8; // Сильніше затухання для коротшого імпульсу

        // Якщо швидкість стала занадто малою, різко зупиняємо
        if (Math.abs(momentum.current) < 2) {
          momentum.current = 0;
          isScrolling.current = false;

          // Після зупинки перевіряємо чи треба доскролити до текстового блоку
          if (snapToTextTimeout.current) {
            clearTimeout(snapToTextTimeout.current);
          }

          snapToTextTimeout.current = setTimeout(() => {
            checkEmptyBlockSnap();
          }, 500);
        }

        // Оновлюємо видимість тексту під час руху
        updateVisibleTexts(scrollPosition.current);
      } else if (isScrolling.current) {
        // Різко зупиняємо інерцію
        momentum.current = 0;
        isScrolling.current = false;

        // Очищаємо існуючий таймаут і запускаємо перевірку доскролу
        if (snapToTextTimeout.current) {
          clearTimeout(snapToTextTimeout.current);
        }

        // Запускаємо таймаут для перевірки пустого блоку
        snapToTextTimeout.current = setTimeout(() => {
          checkEmptyBlockSnap();
        }, 500);
      }

      animationFrameId.current = requestAnimationFrame(animateInertia);
    };

    animationFrameId.current = requestAnimationFrame(animateInertia);

    return () => {
      if (animationFrameId.current) {
        cancelAnimationFrame(animationFrameId.current);
      }

      if (snapToTextTimeout.current) {
        clearTimeout(snapToTextTimeout.current);
      }
    };
  }, [isPreloaded]);

  // Додаємо ініціалізацію для текстів при першому завантаженні
  useEffect(() => {
    if (isPreloaded) {
      // Оновлюємо видимість текстів на початковій позиції
      updateVisibleTexts(scrollPosition.current);
    }
  }, [isPreloaded]);

  // Додаємо функцію, що визначає, чи досягли ми кінця канви
  const isCanvasComplete = () => {
    const isComplete = scrollPosition.current >= NEW_CONTENT_POSITION - 0.5;
    return isComplete;
  };

  // Оновлюємо функцію handleScroll для ще більшого зменшення швидкості скролу батьківського контейнера
  const handleScroll = (deltaY) => {
    if (!isPreloaded) return;

    const maxScroll = NEW_CONTENT_POSITION;

    // Перевіряємо, чи йде доскрол (через функцію snapToPosition)
    const isSnap = isSnapping.current;

    // Якщо ми ще не досягли кінця канви або скролимо вгору, коли канва не на кінці
    if (
      !isCanvasComplete() ||
      (deltaY < 0 && scrollPosition.current < maxScroll)
    ) {
      // Спочатку повністю скролимо канву
      const newScrollPosition = Math.max(
        0,
        Math.min(maxScroll, scrollPosition.current + deltaY)
      );

      // Якщо ми на максимумі і скролимо вниз
      if (newScrollPosition >= maxScroll - 0.5 && deltaY > 0) {
        // Фіксуємо позицію точно на максимум для уникнення неточностей
        scrollPosition.current = maxScroll;

        // Скролимо батьківський контейнер зі зменшеною швидкістю
        if (parentContainerRef.current) {
          // Зменшуємо швидкість батьківського скролу до 15% від оригінальної
          // Змінюємо з 0.2 на 0.15 для ще повільнішого скролу
          const adjustedDeltaY = isSnap ? deltaY : deltaY * 0.15;

          parentContainerRef.current.scrollBy({
            top: adjustedDeltaY,
            behavior: 'auto'
          });
        }
      } else {
        // Інакше скролимо канву
        scrollPosition.current = newScrollPosition;

        // Визначаємо індекс кадру для канви
        const frameIndex = Math.min(
          frameCount - 1,
          Math.floor((scrollPosition.current / maxScroll) * frameCount)
        );

        // Рендеримо кадр і оновлюємо текст
        renderFrame(frameIndex);
        updateVisibleTexts(scrollPosition.current);
        setShowFinalBlock(scrollPosition.current >= FINAL_BLOCK_POSITION);
      }
    } else {
      // Якщо канва вже досягла кінця і ми скролимо вниз
      if (parentContainerRef.current) {
        // Зменшуємо швидкість батьківського скролу до 15% від оригінальної
        // Змінюємо з 0.2 на 0.15 для ще повільнішого скролу
        const adjustedDeltaY = isSnap ? deltaY : deltaY * 0.15;

        // Скролимо батьківський контейнер на зменшену величину deltaY
        parentContainerRef.current.scrollBy({
          top: adjustedDeltaY,
          behavior: 'auto'
        });
      }
    }
  };

  // Додаємо обробник для батьківського скролу
  useEffect(() => {
    const handleParentScroll = () => {
      // Якщо батьківський контейнер скролиться назад до початку
      if (
        parentContainerRef.current &&
        parentContainerRef.current.scrollTop === 0
      ) {
        // Скидаємо блокування скролу канви, щоб можна було знову скролити канву
        if (scrollPosition.current === NEW_CONTENT_POSITION) {
          scrollPosition.current = NEW_CONTENT_POSITION - 1;
        }
      }
    };

    if (parentContainerRef.current) {
      parentContainerRef.current.addEventListener('scroll', handleParentScroll);
    }

    return () => {
      if (parentContainerRef.current) {
        parentContainerRef.current.removeEventListener(
          'scroll',
          handleParentScroll
        );
      }
    };
  }, []);

  // Оновлюємо обробник колеса миші для ще повільнішого скролу
  const handleWheel = (e) => {
    // Зберігаємо час останньої взаємодії і скасовуємо будь-яке поточне притягування
    lastUserInteraction.current = Date.now();
    isSnapping.current = false;

    // Оновлюємо інерцію
    // Якщо канва завершена, ще більше зменшуємо інерцію для батьківського контейнера
    if (isCanvasComplete()) {
      momentum.current = e.deltaY * 0.2; // Зменшуємо до 20% для батьківського контейнера
    } else {
      momentum.current = e.deltaY * 0.5; // Залишаємо оригінальне значення для канви
    }

    isScrolling.current = true;

    handleScroll(e.deltaY);

    // Очищаємо існуючий таймаут дотягування при новому скролі
    if (snapToTextTimeout.current) {
      clearTimeout(snapToTextTimeout.current);
    }

    // Запускаємо таймаут для перевірки пустого блоку після завершення скролу
    snapToTextTimeout.current = setTimeout(() => {
      checkEmptyBlockSnap();
    }, 1000);
  };

  // Оновлюємо обробник дотику зі зменшеною швидкістю
  const handleTouchMove = (e) => {
    // Оновлюємо час останньої взаємодії
    lastUserInteraction.current = Date.now();
    isSnapping.current = false;

    const currentY = e.touches[0].clientY;
    const deltaY = lastTouchY.current - currentY;

    // Встановлюємо інерцію, ще більше зменшуючи її для батьківського контейнера
    if (isCanvasComplete()) {
      // Зменшуємо інерцію для батьківського контейнера
      momentum.current = deltaY * 0.4; // Зменшуємо з 0.5 до 0.4
    } else {
      momentum.current = deltaY * 1.0; // Оригінальне значення для канви
    }

    isScrolling.current = true;

    // Плавніший скрол під час руху пальцем
    handleScroll(deltaY * 5);
    lastTouchY.current = currentY;
    e.preventDefault();
  };

  // Оновлюємо обробник завершення дотику
  const handleTouchEnd = () => {
    // Якщо є інерція, даємо їй короткий імпульс і потім різко зупиняємо
    if (Math.abs(momentum.current) > 0.5) {
      // Встановлюємо фіксовану інерцію для короткого імпульсу
      const currentDirection = Math.sign(momentum.current);
      const initialImpulse = Math.min(15, Math.abs(momentum.current));

      // Встановлюємо початкову інерцію - достатньо сильну для короткого імпульсу,
      // але не настільки, щоб проскролити весь контент
      momentum.current = currentDirection * initialImpulse;

      // Якщо вже є таймаут на притягування, очищаємо його
      if (snapToTextTimeout.current) {
        clearTimeout(snapToTextTimeout.current);
      }

      // Швидше перевіряємо чи потрібно доскролити до текстового блоку
      snapToTextTimeout.current = setTimeout(() => {
        checkEmptyBlockSnap();
      }, 500);
    } else {
      // Якщо інерція занадто мала, відразу зупиняємо
      momentum.current = 0;
      isScrolling.current = false;
    }
  };

  // Події `touchstart` та `touchmove` (для мобільних)
  useEffect(() => {
    const container = containerRef.current;

    const handleTouchStart = (e) => {
      // Зберігаємо час останньої взаємодії і скасовуємо будь-яке поточне притягування
      lastUserInteraction.current = Date.now();
      isSnapping.current = false;

      lastTouchY.current = e.touches[0].clientY;
      // Зупиняємо будь-яку поточну інерцію при новому дотику
      momentum.current = 0;
    };

    const handleTouchMove = (e) => {
      // Оновлюємо час останньої взаємодії
      lastUserInteraction.current = Date.now();
      isSnapping.current = false;

      const currentY = e.touches[0].clientY;
      const deltaY = lastTouchY.current - currentY;

      // Встановлюємо інерцію, ще більше зменшуючи її для батьківського контейнера
      if (isCanvasComplete()) {
        // Зменшуємо інерцію для батьківського контейнера
        momentum.current = deltaY * 0.4; // Зменшуємо з 0.5 до 0.4
      } else {
        momentum.current = deltaY * 1.0; // Оригінальне значення для канви
      }

      isScrolling.current = true;

      // Плавніший скрол під час руху пальцем
      handleScroll(deltaY * 5);
      lastTouchY.current = currentY;
      e.preventDefault();
    };

    if (container) {
      container.addEventListener('touchstart', handleTouchStart, {
        passive: false
      });
      container.addEventListener('touchmove', handleTouchMove, {
        passive: false
      });
      container.addEventListener('touchend', handleTouchEnd);
    }

    return () => {
      if (container) {
        container.removeEventListener('touchstart', handleTouchStart);
        container.removeEventListener('touchmove', handleTouchMove);
        container.removeEventListener('touchend', handleTouchEnd);
      }
    };
  }, [isPreloaded]);

  return (
    <div
      ref={parentContainerRef}
      style={{
        height: '100vh',
        overflowY: 'auto',
        overflowX: 'hidden',
        position: 'relative',
        scrollBehavior: 'auto'
      }}
    >
      {initialLoadComplete && (
        <img
          src={getImageFromS3('images/sms-prl-reg/logo.png')}
          style={{
            position: 'absolute',
            top: 13,
            left: '50%',
            width: '190px',
            transform: 'translate(-50%, 0)',
            height: 'auto',
            zIndex: 6
          }}
          alt="background-gradient"
        />
      )}
      {/* Показуємо іконку скролу тільки якщо showScrollIcon === true */}
      {initialLoadComplete && showScrollIcon && <ScrollIcon />}
      {!initialLoadComplete && <LoadingSpinner progress={totalProgress} />}
      <div style={{ position: 'relative' }}>
        <div
          ref={containerRef}
          style={{
            width: '100%',
            height: '100vh',
            position: 'relative',
            backgroundColor: 'black',
            visibility: initialLoadComplete ? 'visible' : 'hidden'
          }}
          onWheel={handleWheel}
        >
          <img
            src={getImageFromS3('images/sms-prl-reg/background-gradient.png')}
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              zIndex: 5
            }}
            alt="background-gradient"
          />
          <div style={{ height: '100%', position: 'relative' }}>
            {extendedTextElements
              .filter((item) => !item.isEmpty)
              .map((item) => {
                const isVisible = visibleTexts.includes(item.id);

                return (
                  <div
                    key={item.id}
                    style={{
                      position: 'absolute',
                      top: '25%',
                      left: '10%',
                      zIndex: 25,
                      color: 'white',
                      transition: 'all 0.5s cubic-bezier(0.4, 0, 0.2, 1)',
                      opacity: isVisible ? 1 : 0,
                      transform: isVisible
                        ? 'translateX(0)'
                        : scrollPosition.current < item.showAt
                        ? 'translateX(150%)'
                        : 'translateX(-150%)',
                      pointerEvents: 'none',
                      width: '100%'
                    }}
                    dangerouslySetInnerHTML={{ __html: item.html }}
                  />
                );
              })}
            <div
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                zIndex: 20,
                touchAction: 'none'
              }}
            />
            <canvas
              style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                zIndex: 10,
                pointerEvents: 'none',
                width: '200%',
                height: 'auto',
                maxWidth: 'none',
                maxHeight: 'none'
              }}
              ref={canvasRef}
              width={canvasSize.width}
              height={canvasSize.height}
            />
          </div>
        </div>
        <div className={styles.tobacco}>
          <p className={styles.title}>
            Преміальний <br></br> бленд PARLIAMENT
          </p>
          <p className={styles.subTitle}>Три сорти тютюну:</p>
          <div className={styles.tobaccoContent}>
            <img
              src={getImageFromS3('images/sms-prl-reg/tobacco.png')}
              alt="tobacco"
            />
            <div className={styles.typeList}>
              <div className={styles.listItem}>
                <img src={tobaccoCircleLink} alt="circle" />
                <p>Берлі</p>
              </div>
              <div className={styles.listItem}>
                <img src={tobaccoCircleLink} alt="circle" />
                <p>Вірджинія</p>
              </div>
              <div className={styles.listItem}>
                <img src={tobaccoCircleLink} alt="circle" />
                <p>Орієнтал</p>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.buyContainer}>
          <p className={styles.title}>Де купити?</p>
          <p className={styles.description}>
            Актуальний асортимент можна знайти у роздрібних точках продажу в
            твоєму місті або на офіційних онлайн сервісах, зокрема:
          </p>
          <div className={styles.buttonContainer}>
            <div
              className={styles.firstButton}
              onClick={() => {
                sendEvent('Cig-Poshta');
                window.open(shopLink.cigPoshta, '_blank');
              }}
            >
              Cig-poshta
            </div>
            <div
              className={styles.secondButton}
              onClick={() => {
                sendEvent('rozetka');
                window.open(shopLink.rozetka, '_blank');
              }}
            >
              Rozetka
            </div>
          </div>
        </div>
        <div className={styles.footer}>
          Куріння викликає серйозні захворювання та залежність Дана інформація
          про продукт надається відповідно до статті 15 Закону України «Про
          захист прав споживачів»
        </div>
        <div className={styles.unsubscribe}>
          Ти отримав(-ла) лист, оскільки залишав(-ла) запит на отримання
          інформації про продукцію компаній Philip Morris в Україні. <br />
          <a href="/unsubscribe?returnLink=25-sms-prl-reg-test">
            Відписатися від SMS тут.
          </a>
        </div>
      </div>
    </div>
  );
};

export default SmsPrlReg;
